
@if(showProgressBar){
    <p-progressBar  class="loader-bar" [value]="50" mode="indeterminate"></p-progressBar>
}
